import { isCssVar } from './utils';
var customSyntaxRegex = /"\w+\([^"]*\)"/g;
var CustomSyntaxHelper = /** @class */ (function () {
    function CustomSyntaxHelper() {
        this.vars = {};
        this.customSyntaxStrs = [];
    }
    CustomSyntaxHelper.prototype.extractVar = function (key, value) {
        if (isCssVar(key)) {
            this.vars[key] = value;
        }
    };
    CustomSyntaxHelper.prototype.extractCustomSyntax = function (key, value) {
        var _a;
        var match = value.match(customSyntaxRegex);
        if (match) {
            (_a = this.customSyntaxStrs).push.apply(_a, match);
        }
    };
    CustomSyntaxHelper.prototype.getValue = function (varName) {
        return this.vars[varName];
    };
    return CustomSyntaxHelper;
}());
export { CustomSyntaxHelper };
//# sourceMappingURL=customSyntaxHelper.js.map